export interface IDisplayUrl {
    urlLink: string
    urlDisplayText: string,
    urlTarget?: string
}

export class DisplayUrl implements IDisplayUrl {
    urlLink: string;
    urlDisplayText: string;

    constructor(urlDisplayText: string, urlLink: string, urlTarget?: string) {
        this.urlLink = urlLink;
        this.urlDisplayText = urlDisplayText;
    }

    static isDisplayUrl(obj: any): obj is IDisplayUrl {
        return (
            obj !== null &&
            typeof obj === 'object' &&
            'urlLink' in obj &&
            'urlDisplayText' in obj
        );
    }
}